// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page.col-layout {
    display: flex;
    flex: 1;
    flex-direction: column-reverse;
    justify-content: center;
    width: 100%;
    min-height: 0;
    padding-top: 0;
    padding-bottom: 0;
    align-items: flex-start;
    background: var(--ce-com-gradient);
}

.user-coordinator .login-page .brand-sidebar,
.user-coordinator .login-page .authentication-action {
    width: 100%;
    overflow: auto;
}
/* left stuff */
.user-coordinator .login-page .brand-sidebar {
    display: flex;
    flex-direction: column;
    max-height: 100%;
    padding: var(--card-padding);
    align-items: center;
}

/* right stuff */
.user-coordinator .login-page .authentication-action {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    background: var(--ce-grey-1);
    padding: calc(var(--card-padding) + var(--lg_padding)) var(--card-padding);
}
.form-buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    border-bottom: var(--border);
    margin-bottom: 10px;
    row-gap: var(--md_padding);
}
.login-page a.try-mdh {
    width: var(--form-width);
}

@media (min-width: 768px) {
    #authentication.user-coordinator {
        height: 100dvh;
    }
    #authentication.user-coordinator .col-layout {
        flex-direction: row;
    }
    .user-coordinator .brand-sidebar,
    .user-coordinator .authentication-action {
        width: 50%;
    }
}

/* Change to min-width */
@media (max-width: 767px) {
    /* .user-coordinator .brand-sidebar,
  .user-coordinator .authentication-action {
    width: 100%;
    flex: 1;
    padding: 10px;
    align-items: center;
    justify-content: center;
  } */
}

/* ??? Dylan stuff */
.non-existent-account-button {
    margin-bottom: 1rem;
    text-transform: capitalize;
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Coordinator/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,OAAO;IACP,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;;IAEI,WAAW;IACX,cAAc;AAClB;AACA,eAAe;AACf;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,4BAA4B;IAC5B,0EAA0E;AAC9E;AACA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,4BAA4B;IAC5B,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,mBAAmB;IACvB;IACA;;QAEI,UAAU;IACd;AACJ;;AAEA,wBAAwB;AACxB;IACI;;;;;;;KAOC;AACL;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,0BAA0B;AAC9B","sourcesContent":[".login-page.col-layout {\n    display: flex;\n    flex: 1;\n    flex-direction: column-reverse;\n    justify-content: center;\n    width: 100%;\n    min-height: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    align-items: flex-start;\n    background: var(--ce-com-gradient);\n}\n\n.user-coordinator .login-page .brand-sidebar,\n.user-coordinator .login-page .authentication-action {\n    width: 100%;\n    overflow: auto;\n}\n/* left stuff */\n.user-coordinator .login-page .brand-sidebar {\n    display: flex;\n    flex-direction: column;\n    max-height: 100%;\n    padding: var(--card-padding);\n    align-items: center;\n}\n\n/* right stuff */\n.user-coordinator .login-page .authentication-action {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100%;\n    background: var(--ce-grey-1);\n    padding: calc(var(--card-padding) + var(--lg_padding)) var(--card-padding);\n}\n.form-buttons {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 10px;\n    border-bottom: var(--border);\n    margin-bottom: 10px;\n    row-gap: var(--md_padding);\n}\n.login-page a.try-mdh {\n    width: var(--form-width);\n}\n\n@media (min-width: 768px) {\n    #authentication.user-coordinator {\n        height: 100dvh;\n    }\n    #authentication.user-coordinator .col-layout {\n        flex-direction: row;\n    }\n    .user-coordinator .brand-sidebar,\n    .user-coordinator .authentication-action {\n        width: 50%;\n    }\n}\n\n/* Change to min-width */\n@media (max-width: 767px) {\n    /* .user-coordinator .brand-sidebar,\n  .user-coordinator .authentication-action {\n    width: 100%;\n    flex: 1;\n    padding: 10px;\n    align-items: center;\n    justify-content: center;\n  } */\n}\n\n/* ??? Dylan stuff */\n.non-existent-account-button {\n    margin-bottom: 1rem;\n    text-transform: capitalize;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
